import Vue from "vue";
export default {
  SET_PATIENTS: (state, payload) => {
    state.patients = payload;
  },
  SET_ROLES: (state, payload) => {
    state.roles = payload;
  },
  SET_ROLE: (state, payload) => {
    state.role = payload;
  },
  SET_FIRSTNAME: (state, payload) => {
    state.firstName = payload;
  },
  SET_LASTNAME: (state, payload) => {
    state.lastName = payload;
  },
  SET_USERNAME: (state, payload) => {
    state.username = payload;
  },
  SET_PASSWORD: (state, payload) => {
    state.password = payload;
  },
  SET_CONFIRM: (state, payload) => {
    state.confirm = payload;
  },
  SET_MOBILE: (state, payload) => {
    state.mobile = payload;
  },
  SET_DATE_OF_BIRTH: (state, payload) => {
    state.dateOfBirth = payload;
  },
  SET_MOBILE_COUNTRY_ID: (state, payload) => {
    state.mobileCountryId = payload;
  },
  SET_SPOUSE_FIRST_NAME: (state, payload) => {
    state.spouseFirstName = payload;
  },
  SET_SPOUSE_LAST_NAME: (state, payload) => {
    state.spouseLastName = payload;
  },
  SET_SPOUSE_NATIONALCODE: (state, payload) => {
    state.spouseNationalCode = payload;
  },
  SET_SPOUSE_COUNTRY_ID: (state, payload) => {
    state.spouseCountryId = payload;
  },
  SET_SPOUSE_IDENTITYCODE: (state, payload) => {
    state.spouseIdentityCode = payload;
  },
  SET_FATHERNAME: (state, payload) => {
    state.fatherName = payload;
  },
  SET_NATIONALCODE: (state, payload) => {
    state.nationalCode = payload;
  },
  SET_MARITALSTATUS: (state, payload) => {
    state.maritalStatus = payload;
  },
  SET_OTHERCODE: (state, payload) => {
    state.otherCode = payload;
  },
  SET_MOBILES: (state, payload) => {
    state.mobiles = payload;
  },
  SET_COUNTRY: (state, payload) => {
    state.country = payload;
  },
  SET_CITY: (state, payload) => {
    state.city = payload;
  },
  SET_PROVINCE: (state, payload) => {
    state.province = payload;
  },
  SET_ISSUEDPROVINCE: (state, payload) => {
    state.issuedProvince = payload;
  },
  SET_BIRTHPROVINCE: (state, payload) => {
    state.birthProvince = payload;
  },
  SET_ISSUEDCITY: (state, payload) => {
    state.issuedCity = payload;
  },
  SET_BIRTHCITY: (state, payload) => {
    state.birthCity = payload;
  },
  SET_GENDER: (state, payload) => {
    state.gender = payload;
  },
  SET_ADDRESSES: (state, payload) => {
    state.addresses = payload;
  },
  SET_ADDRESSTYPES: (state, payload) => {
    state.addressTypes = payload;
  },
  SET_EMAIL: (state, payload) => {
    state.email = payload;
  },
  SET_PHONES: (state, payload) => {
    state.phones = payload;
  },
  SET_REFERRAL_WAYS: (state, payload) => {
    state.referralWays = payload;
  },
  SET_REFERRAL_WAY: (state, payload) => {
    state.referralWay = payload;
  },
  SET_REFERRER_NAME: (state, payload) => {
    state.referrerName = payload;
  },
  SET_REFERRER_USER: (state, payload) => {
    state.referrerUser = payload;
  },
  SET_REFERRER_USERS: (state, payload) => {
    state.referrerUsers = payload;
  },
  SET_REFERRER_ADDRESS: (state, payload) => {
    state.referrerAddress = payload;
  },
  SET_REFERRER_NATIONALCODE: (state, payload) => {
    state.referrerNationalCode = payload;
  },
  SET_PATIENT_TO_EDIT: (state, payload) => {
    state.patientToEdit = payload;
  },
  SET_USERS_TO_ADD: (state, payload) => {
    state.usersToAdd = payload;
  },
  SET_SPOUSES: (state, payload) => {
    state.spouses = payload;
  },
  SET_TOTAL: (state, payload) => {
    state.total = payload;
  },
  
};
